// Module
var code = `<template>
  <require from="./cost-breakdown-widget.scss"></require>
  <require from="../../../converters/column-widths-converter"></require>

  <div class="cost-breakdown-widget cost-breakdown-widget-\${id}">
    <!-- beautify ignore:start -->
    <style if.bind="rowHeight">
      .cost-breakdown-widget-\${id} tr {
        height: \${rowHeight}px !important;
      }
    </style>

    <style>
      .cost-breakdown-widget-\${id} {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .cost-breakdown-widget-\${id} th {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>

    <table if.bind="!loading && !error" class="widget-table">
      <thead>
        <tr>
          <th style="\${columnWidths | columnWidths:0}" class="cost-breakdown-widget__name">Name</th>
          <th style="\${columnWidths | columnWidths:1}" class="cost-breakdown-widget__isin">ISIN/Org.nr</th>
          <th style="\${columnWidths | columnWidths:2}" class="widget-table__numeric">Quantity</th>
          <th style="\${columnWidths | columnWidths:3}">Curr</th>
          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">Curr. Amount</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">Curr. Amount(Avg)</th>
          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">Amount</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">Amount(Avg)</th>
           <th if.bind="displayFifo" style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">Curr. Amount Period</th>
           <th if.bind="displayAvg" style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">Curr. Amount Period (Avg)</th>
           <th if.bind="displayFifo" style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">Amount Period</th>
           <th if.bind="displayAvg" style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">Amount Period(Avg)</th>
        </tr>
      </thead>
      <tbody>
        <tr repeat.for="v of data" class="\${v.groupTotal || v.isGroupTotal ? 'widget-table__group-total' : ''} \${v.isHeader ? 'cost-breakdown-widget__header-row' : ''} \${v.isChild ? 'cost-breakdown-widget__child-row' : ''} \${v.hasChildren ? 'cost-breakdown-widget__with-children' : ''} \${v.isLastChild ? 'cost-breakdown-widget__last-child' : ''}">
          <td style="\${columnWidths | columnWidths:0}" class="cost-breakdown-widget__name">
            <span class="\${v.isChild ? 'cost-breakdown-widget__child-indent' : ''}">
              \${v.name}
            </span>
          </td>
          <td style="\${columnWidths | columnWidths:1}" class="cost-breakdown-widget__isin">
            <span if.bind="v.isHeader && !v.isChild">\${v.isin || v.orgNr}</span>
          </td>
          <td style="\${columnWidths | columnWidths:2}" class="widget-table__numeric">
            \${v.quantity | numericFormatter:quantityPrecision}
          </td>
          <td style="\${columnWidths | columnWidths:3}">
            <span if.bind="v.isChild || (v.isHeader && !v.hasChildren)">\${v.currencyCode}</span>
          </td>
          <td if.bind="displayFifo" style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">
            <span if.bind="v.isChild || (v.isHeader && !v.hasChildren)">
              \${v.totalCostPriceInCurrency | numericFormatter:precision}
            </span>
          </td>
          <td if.bind="displayAvg" style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">
            <span if.bind="v.isChild || (v.isHeader && !v.hasChildren)">
              \${v.avgTotalCostPriceInCurrency | numericFormatter:precision}
            </span>
          </td>
          <td if.bind="displayFifo" style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">
            \${v.totalCostPrice | numericFormatter:precision}
          </td>
          <td if.bind="displayAvg" style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">
            \${v.avgTotalCostPrice | numericFormatter:precision}
          </td>
          <td if.bind="displayFifo" style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">
            <span if.bind="v.isChild || (v.isHeader && !v.hasChildren)">
              \${v.totalCostPriceInCurrencyInPeriod | numericFormatter:precision}
            </span>
          </td>
          <td if.bind="displayAvg" style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">
            <span if.bind="v.isChild || (v.isHeader && !v.hasChildren)">
              \${v.avgTotalCostPriceInCurrencyInPerio | numericFormatter:precision}
            </span>
          </td>
           <td if.bind="displayFifo" style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">
             \${v.totalCostPriceInPeriod | numericFormatter:precision}
             <promise-resolver resolve.bind="lastItemRendered" if.bind="\$last"></promise-resolver>
           </td>
          <td if.bind="displayAvg" style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">
            \${v.avgTotalCostPriceInPeriod | numericFormatter:precision}
            <promise-resolver resolve.bind="lastItemRendered" if.bind="\$last"></promise-resolver>
          </td>
        </tr>
      </tbody>
    </table>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;